// Staff
const StaffList = () => import('@/views/staff/StaffList.vue')
const StaffForm = () => import('@/views/staff/StaffForm.vue')
const StaffView = () => import('@/views/staff/StaffView.vue')

export const staffRoutes = [
  {
    path: '/staff',
    name: 'Staff',
    component: StaffList,
    meta: {
      requireAuth: true,
      title: 'Staff'
    }
  },
  {
    path: '/staff/new',
    name: 'NewStaff',
    component: StaffForm,
    meta: {
      requireAuth: true,
      title: 'New Staff'
    }
  },
  {
    path: '/staff/:id',
    name: 'ViewStaff',
    component: StaffView,
    meta: {
      requireAuth: true,
      title: 'View Staff'
    }
  },
  {
    path: '/staff/:id/edit',
    name: 'EditStaff',
    component: StaffForm,
    meta: {
      requireAuth: true,
      title: 'Edit Staff'
    }
  }
]
